export const BASE_PATH = '/disability-insurance/quotes';

// Survey routes
export const SURVEY_BASICS_PATH = '/survey/basics';
export const HOUSEHOLD_PATH = '/survey/household';
export const BENEFIT_AMOUNT_PATH = '/survey/benefit-amount';
export const OCCUPATION_PATH = '/survey/occupation';
export const WAITING_PERIOD_PATH = '/survey/waiting-period';
export const BENEFIT_PERIOD_PATH = '/survey/benefit-period';
export const POLICY_FEATURES_PATH = '/survey/policy-features';

// Health routes
export const HEALTH_BASICS_PATH = '/health/basics';
export const DEPRESSION_PATH = '/health/t2pb5ya2';
export const DIABETES_PATH = '/health/ij3c9fe5';
export const SLEEP_APNEA_PATH = '/health/u8iyzuby';
export const BLOOD_PRESSURE_PATH = '/health/pobmcjf3';

// Application routes
export const APPLICATION_PATH = '/applications/form';
